import axios from 'axios';

// Upper time bound for bootstrap/auth HTTP calls. Deliberately above the
// ~29s legitimate slow-tail max for GET /dispatch/auth/users so valid slow
// calls aren't killed; this only kills calls that have genuinely stalled,
// letting the app fail fast and recover instead of hanging indefinitely.
export const BOOTSTRAP_HTTP_TIMEOUT_MS = 45000;

export const dispatchClient = axios.create({
  timeout: BOOTSTRAP_HTTP_TIMEOUT_MS,
});
export const dispatchClient_WUS = axios.create({
  baseURL: 'https://api-wus.ngsapps.net',
  timeout: BOOTSTRAP_HTTP_TIMEOUT_MS,
});
export const dispatchClient_EUS = axios.create({
  baseURL: 'https://api-eus.ngsapps.net',
  timeout: BOOTSTRAP_HTTP_TIMEOUT_MS,
});
